module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One:")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hitler’s First Russian Winter")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("001ww2/3 The four week Russian seasonal heavy rain in October–November (the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rasputitsa)")]), _vm._v(" slowed down the German advance during the Battle of Moscow and may have helped save the Soviet capital. German infantry help free a Horch/Opel staff car.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("002ww2/3 The rooftop of Moscow's "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hotel Moskva")]), _vm._v(", November 1941 when the Germans were approaching the capital: a Russian anti-aircraft position with quad mounted Maxim machine guns. Note the painted compass rose for direction and sighting assistance.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The German offensive to capture Moscow")]), _vm._v(", which lasted from October 1941 to January 1942, was called Operation Typhoon and required three assaults, one to the north of Moscow by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Third Panzer Army")]), _vm._v(" and another from the south by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Second Panzer Army")]), _vm._v(". A third drive was by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fourth Army,")]), _vm._v(" advancing directly towards Moscow from the west. The Russians took determined defensive measures and frustrated Hitler's attack on their capital. Three defensive belts were constructed; newly raised reserve armies were deployed; and troops were brought back from the Siberian and Far Eastern Military Districts. As the German offensives were stopped, a Soviet counter-offensive forced the Germans back to positions around the cities of Oryol, Vyazma and Vitebsk. It was a major setback for Hitler ending the notion that a speedy military victory for Germany could be achieved. The Führer was displeased and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalfeldmarschall")]), _vm._v(" Walther von Brauchitsch was removed as supreme commander and Hitler (a corporal in the Great War) took over the role himself.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p10-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalfeldmarschall")]), _vm._v(" Günther von Kluge commanded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fourth Army")]), _vm._v(" during Operation Typhoon, the German advance on Moscow. It was suspected that he had been involved in the 20 July plot (by fellow German officers) on Hitler’s life and committed suicide, August 1944.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p10-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Erich Hoepner commanded "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panzergruppe 4")]), _vm._v(", which was subordinated to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fourth Army")]), _vm._v(" under von Kluge. He was implicated in the 20 July plot against Adolf Hitler. He received a public trial and was executed by hanging in 1944. Family members were sent to concentration camps.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p10-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("003ww2/3 A German armoured column 0f the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("20.Panzerdivision")]), _vm._v(" advancing towards Moscow, October 1941. A heavy frost decorates the landscape and the ground appears hard; this would soon change.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p11-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("004ww2/3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalfeldmarschall")]), _vm._v(" Walther von Brauchitsch with Adolf Hitler. Failure to capture Moscow and win a quick victory over the ‘inferior’ race caused Hitler to remove him from command. Brauchitsch suffered a heart attack in November 1941, which also served as an excuse. He spent the rest of the war in enforced retirement. After the war, Brauchitsch was arrested on charges of war crimes but died of pneumonia in 1948 before he could be prosecuted.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p11-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption-c"
  }, [_vm._v("015ww2/3 General Günther Blumentritt, Chief of Staff Fourth Army.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In mid October "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group Centre")]), _vm._v(" set off for Moscow. All that lay between the Germans and the capital was the so-called Moscow Defensive Position. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("General Günther Blumentritt")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We had no reason to believe that this would prove a particularly difficult nut to crack.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Once we were through that, the road, we thought, would be open. Now, when Moscow itself was almost in sight, the mood of our commanders and troops changed. With amazement we discovered in late October and early November that the beaten Russians seemed quite unaware that as a military force they had almost ceased to exist. During these weeks enemy resistance stiffened and the fighting became more bitter with each day that passed. Marshal Zhukov had now assumed command of the troops defending Moscow.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption-c"
  }, [_vm._v("018ww2/3 Marshal Georgy Zhukov commanded the defence of Moscow.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("013ww2/3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Feldmarschall")]), _vm._v(" Fedor von Bock commanded Army Group Centre seen here during the opening phase of the drive to capture Moscow.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("019ww2/3 An incident on the approaches to Moscow: a Russian soldier surrenders to a German armed with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maschinenpistole")]), _vm._v(" 40 (MP40). Perhaps a posed picture as there appears to be no magazine in the MP40. Bad weather and stiffening resistance will soon halt the German attack.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("020ww2/3 Soviet snipers suitably attired for the anticipated change in the Russian weather.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p13-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("012ww2/3, 021ww2/3. Russian women digging an anti-tank ditch on one of the city’s outer defence rings. Men building a substantial road block on a Moscow street: a concrete line of shelters; weapon positions; Czech hedgehogs; and anti-tank ditch. These defences would not be tested.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p14-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("026ww2/3 German panzers and infantry in the streets of Kalinin, one hundred miles north of Moscow, October 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("027ww2/3 German artillery men south of Moscow, October 1941. The first snow of the Russian winter fell on 7 October. These men have scrounged some winter coats, mittens and boots. The artillery piece is a Skoda 100 mm howitzer.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("039ww2/3 The first snow, heralding the onset of a Russian winter, caught the German army unprepared, as this squad before Moscow typifies. A German infantry "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gruppe")]), _vm._v(" (squad) consisted of ten men: a non-commissioned officer or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unteroffizier")]), _vm._v("; a deputy squad leader: a three-man machine gun team and five riflemen. As personal small arms the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gruppe")]), _vm._v(" leaders carried submachine guns.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("023ww2/3 On 7 October 1941 the first snow fell and German soldiers were caught unprepared and ill equipped for the Russian winter, as they engaged in the battle for Moscow.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("024ww2/3 Transport for the German rifle companies in 1941 consisted of three-horse wagons, on which the troops loaded their packs. 179,000 horses died in December 1941 and January 1942 alone.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("022ww2/3, 025ww2/3. When the first snow melted after the first week of October, roads and open ground became muddy quagmires, (a bi-annual event known as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rasputitsa")]), _vm._v(" in Russia). A German motorcyclist struggles to find hard ground for his NSU machine. An 88 mm anti-aircraft/anti-tank, although hauled by a tracked vehicle, is proving difficult to bring into position. German armour and support transport came to a standstill, allowing Soviet forces to fall back and regroup.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("032ww2/3, 031ww2/3. The days of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blitzkrieg")]), _vm._v(" were over. Here a motorcycle and sidecar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("abteilung")]), _vm._v(" have to drag their BMW machines across waterlogged fields.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Following the thaw and mud, the temperature plunged to forty degrees centigrade below zero. Weapons were immediately affected. The lubricant fluid of the artillery pieces froze, making opening of the gun breech difficult and the mechanism of the machine guns froze. The German army did not have glycerine, nor fuel, designed for use in extreme temperatures. Fires had to be kept burning under tank engines to prevent freezing up and cracking of the casing. The ground was like iron, making digging all but impossible. Then the heavy winter snow descended.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("035ww2/3 Germans tend a fallen comrade brought down during an advance on a Russian town. Both sides had bombarded clusters of dwellings and single farms, but with the extreme cold, they could have done with the shelter.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p17-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("037ww2/3 A Russian artillery team hauling a 76 mm field gun. The Russians were also affected by the conditions, but were far better off. The extreme cold was no novelty to them; they were accustomed to it. With Moscow behind them, the supply line to the front was short, whereas the German supply line was over a great distance and was frequently cut by partisans. The German railway engines were not built to withstand the Russian climate and water froze inside the boilers. Their engines could only pull half the number of wagons and a shortage of artillery shells developed.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("034ww2/3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Franz Halder, Chief of the German General Staff.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Deteriorating weather caused Chief of the German General Staff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Franz Halder, to call for a meeting of the chiefs of staff of the armies in von Bock’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group Centre")]), _vm._v(" on 12 November at Army Group Centre’s HQ at Orsha (310 miles west of Moscow). The matter for discussion was a simple one: should "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group Centre")]), _vm._v(" take up ‘winter quarters’, and make plans to campaign in 1942, or should it continue the attack?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The meeting elicited a storm of protests against further advance from some of the chiefs of staff. But, in the end, Halder’s decision was that the advance to Moscow be continued.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p18-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("033ww2/3 German armour attacking Istra, twenty-five miles west of Moscow, 25 November 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p19-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("036ww2/3 A German infantry squad resting during the advance on Moscow. By 15 November 1941, the ground had finally frozen, solving the mud problem.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("038ww2/2 German tanks and supporting infantry advancing into a village in the district of Volokolamsk during the battle of Moscow.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("041ww2/3 The original German caption reads: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Soldiers of the Panzergrenadier Division")]), _vm._v(" Das Reich "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("make themselves at home.")]), _vm._v(" It was the worst winter in 120 years.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("040ww2/3 Soldiers of the SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Das Reich")]), _vm._v(" west of Moscow. The original German caption reads: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apart from the winter, the Russian T 34 tank was the big surprise, the 3.7 cm anti-tank gun could do nothing against it, so the men manufactured ‘Panzer cocktails’. The front line soldier has to know how to improvise.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("039ww2/2 The German front line west of Moscow, December 1941. German fighting capabilities had diminished because of wear and fatigue. More than 130,000 cases of frostbite were reported among German soldiers. At the same time, the Germans were aware of the continuous Soviet build-up, reinforcements from the east. However, given the tremendous Soviet casualties, they did not expect the Russians to be able to put up a determined defence or to mount a counterattack.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p21-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("105ww2/3 A German column rolling on towards Moscow; movement is still possible with the first snow. A Stug Ausf B, a self-propelled 75 mm gun, leads the column of Sd Kfz armoured cars.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p21-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("106ww2/3 With temperatures at night falling to forty degrees centigrade below zero, fuel and lubricants froze, weapons ceased to function and vehicles froze into the icy ground. Here a Panzer III drags a Stug out of trouble.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p22-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("107ww2/3 Not a sight German soldiers ever expected to see: pulling back a thick horse blanket has revealed three of their comrades who have frozen to death on the battlefield before Moscow.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("By the end of November 1941 Stalin had transferred over eighteen divisions, 1,700 tanks, and over 1,500 aircraft from Siberia and the Far East to remove the threat to Moscow. On 5 December 1941, the Soviet counteroffensive started on the Kalinin Front. Russian arimies on the South-Western Front and Western Fronts began their offensives the next day. After little progress initially, Soviet armies retook Solnechnogorsk on the 12 and Klin on 15 December.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("042ww2/3 Lieutenant General Aleksandr Vasilevsky coordinated the Moscow counteroffensive, which began in December.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("043ww2/3 The Russian T-34/76A medium tank. It had a 76.2 mm gun with seventy-seven rounds, a crew of four and a range of 280 miles. It came as a shock to the Germans and set the standard for tank design for the world’s fighting forces.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("044ww2/3, 047ww2/3 Soldiers of the Red Army leaving for the front after a parade on Moscow’s Red Square")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p24-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("054ww2/3 Marshal Zhukov Commanded the successful defence of Moscow and the massive counter offensive to drive the invaders back from the Soviet capital.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p24-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group Centre")]), _vm._v(" had orders from Hitler to stand and fight, contending every metre of ground. Had the German generals attempted a strategic withdrawal of their forces over frozen snow and ice covered ground, it likely would have turned into a total collapse. Fighting withdrawals were undertaken in the face of fierce Soviet attacks..")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("050ww2/3 A Soviet 122 mm gun in action near Moscow, December 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("051ww2/3 On 5 December, 1941, Stalin launched his counter-offensive against the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wehrmacht")]), _vm._v(". He had transferred over eighteen divisions, 1,700 tanks and over 1,500 aircraft from Siberia and the Far East. The T 34 tank faired better than the German tanks in the extreme cold.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p25-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("052ww2/3 Supporting the Soviet counter attack, a formation of Russian Ilyushin Il-2 Shturmovik, ground attack, fighter bombers, near Moscow, December 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Soviet Ilyushin Il-2 Shturmovik, ground attack aircraft could absorb extensive battle damage. Protective armour on the Il-2 led to it being given the nickname, Betonflugzeug (concrete plane), by the Germans. Some 35,000 were produced during the war, more than any other combat aircraft.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("046ww2/3 The moment of surrender – a German soldier ceases to resist. Freezing, exhausted and hungry Germans were giving up to the Russians during the Soviet counter offensive. Used to victories across Europe, professional veterans had been pushed to their limit by Hitler.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("049ww2/3 Soviet officers inspecting captured German troops and weapons, near Moscow, Russia, 20 Dec 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("045ww2/3 A frame from a Soviet newsreel showing some surrendering German soldiers west of Moscow.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the Soviet forces moving to encircle and destroy the German Fourth Army attacking Moscow, the commander, von Kluge, planned a withdrawal westwards to straighten the line. He called a meeting of his commanders at his headquarters to begin organising in detail the withdrawal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("General Günther Blumentritt")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("At that point a telephone call came through from the Chief of Staff,")]), _vm._v(" Army Group Centre"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", who told me, ‘You had better make yourself comfortable where you are. A new order has has just arrived from Hitler,")]), _vm._v(" Fourth Army "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is not to retreat a single yard.’ As far as we generals could see this would mean the destruction of the")]), _vm._v(" Fourth Army"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(". Yet we obeyed this order. Hitler had just taken over the position as Commander-in-Chief after dismissing von Brauchitsch; he believed that he personally could ward off the catastrophe that was impending before Moscow. And it must be admitted, quite frankly, that he in fact succeeded in doing so. His fanatical order that the troops must hold fast was undoubtedly correct. Hitler realized, instinctively, that any retreat across snow and ice must, within days, lead to the dissolution of the entire front and the Germans would suffer the same fate as Napoleon’s")]), _vm._v(" Grande Armée "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in 1812.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p27-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("016ww2/3 General Blumentritt, Chief of Staff Fourth Army.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("055ww2/3 Hitler visited the leader of the Finns, Carl Gustaf Emil Mannerheim, 4 June 1942, on the occasion of his 75th birthday. The Finnish army invaded Russia from the north, co-operating with the Germans until Finland had recaptured territory lost in their recent Winter War with the Soviets; but they refused to make further advances on Leningrad.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Führer Directive 21: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The mass of the Finnish army will have the task, in accordance with the advance made by the northern wing of the German armies, of tying up maximum Russian strength by attacking to the west, or on both sides, of Lake Ladoga")]), _vm._v(". On 8 September 1941, the road to the besieged city was cut when the Germans reached Lake Ladoga, leaving a narrow corridor of land between Lake Ladoga and Leningrad.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("057ww2/3 A German machine gun position in the suburbs of Leningrad, September 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p28-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("058ww2/3 A barge on Lake Ladoga unloading supplies onto a narrow gauge diesel train for the besieged citizens of Leningrad.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("061ww2/3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Alfred Josef Ferdinand Jodl, Chief of the Operations Staff for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberkommando der Wehrmacht")]), _vm._v(" (the Armed Forces High Command). On 7 October, Hitler sent a directive signed by Jodl reminding "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group North")]), _vm._v(" not to accept capitulation at Leningrad. The besieged defenders were to be starved out.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("060ww2/3 Russians civilians leaving an apartment block following its destruction by shelling. The Germans had calculated that the city’s inhabitants would reach starvation point in a matter of weeks.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("063ww2/3 Removing bodies from a Leningrad street, victims of German shelling.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("062ww2/3 Sticking up a warning poster in Leningrad: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Citizens! This part of the street is very dangerous during an artillery barage.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("059ww2/3 Soviet defenders of Leningrad in trenches with a Degtyaryov light machine gun (DP 27), September 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("065ww2/3 Queuing for water in Leningrad during the winter of 1941. The siege started on 8 September, when the Germans severed the last road to the city. The Red Army did not lift the siege until 27 January 1944, 872 days after it began. It was one of the longest sieges in history,")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p30-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("064ww2/3 Soviet defenders carrying a wounded comrade out of the Line.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("066ww2/3 General Lieutenant Pavel Kurochkin, commander of the Russian Northwestern Front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("067ww2/3 Germans trapped in the Demyansk pocket. It was another example of the invincible German army being delivered shocks by the Soviet forces that were supposed to have been defeated by the end of Operation Barbarossa in 1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Soviet commander of the Russian Northwestern Front, General Lieutenant Pavel Kurochkin, instigated pincer attacks and a surrounding of German troops by the Red Army around Demyansk, south of Leningrad. The encirclement began as the Demyansk Offensive Operation, carried out from 7 January to 20 May 1942. The resulting pocket existed from 8 February to 21 April 1942. The fighting had taken a heavy toll. Out of the approximately 100,000 men originally in the pocket, there were 3,335 killed and over 10,000 wounded. A smaller German force was surrounded at the town of Kholm, about sixty miles to the southwest.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Generaloberst")]), _vm._v(" Ernst Busch, commander of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sixteenth Army,")]), _vm._v(" elements of which were surrounded in two pockets. Busch was able to relieve his encircled troops when the Red Army offensive shifted focus towards "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group Centre")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("068ww2/3 The successful defence of the Demyansk pocket was made possible through the use of an airbridge where vital supplies were flown in by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Transportgruppen")]), _vm._v(" of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luftwaffe")]), _vm._v(". The same method would be attempted to supply the beleaguered "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sixth Army")]), _vm._v(" at Stalingrad; resulting in heavy losses of aircraft and little success, in December 1942.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("070ww2/2 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalmajor")]), _vm._v(" Erich von Manstein, commander "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("11.Armee")]), _vm._v(" September 1941 to November 1942.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eleventh Army")]), _vm._v(" under von Manstein was ordered to invade the Crimean Peninsula, taking Sevastopol and pursuing the enemy forces on the flank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Army Group South")]), _vm._v(" during its advance into the Soviet Union. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eleventh Army")]), _vm._v(" was to prevent the Red Army from using airbases in the Crimea and to cut off Soviet supply of oil from the Caucasus. Manstein’s command had to capture the entire Peninsula, which was accomplished – except for Sevastopol – by 16 November 1941. The Soviet naval base of Sevastopol finally surrendered 4 July 1942.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-r"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Photographs taken of the 11.Armee during its conquest of the Crimea.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("071ww2/3 Two noncommissioned officers of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eleventh Army,")]), _vm._v(" armed with MP40 machine pistols.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("077ww2/3 Simferopol, the capital city of the Crimea, was reached at the beginning of November 1941. Two Germans operating a 50 mm Pak 38. One soldier has a Russian SVT40 semi-automatic sniper rifle over his shoulder. The weapon was considered useful by the German army and they produced their own manual for troops to use when issued with captured examples.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p32-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("076ww2/3 Original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A motorized infantry advance guard has come under fire and they dismount to return fire.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("073ww2/3 A Horch car at the spearhead of the force driving towards the Yayla Mountains in the south. Extra sheets of armour plate can be seen at the front. Note the national flag draped on the bonnet for identification.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("072ww2/3 A mounted unit on the road south.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("075ww2/3 General Manstein’s Kfz.21 command vehicle struggling in the mud of winter.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("074ww2/3 Original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("German troops shelter their horses in dugouts to protect them from shell fragments.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p33-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("075ww2/3 Original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Even the army commander’s car can get stuck.")]), _vm._v(" Erich von Manstein in the front of his Horch Command vehicle during the thrust into the Crimea.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("089ww2/3 The recently captured capital of Crimea, Simferopol: a mixed crowd of German soldiers and Russian civilians listen to a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wehrmacht")]), _vm._v(" situation report broadcast in Russian and the Tatar language.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("092ww2/3, 093ww2/3.The south coast town of Yalta, on the Black Sea, is reached by the advanced party. Under shelter from the Yayla mountain range the weather is warmer for the invaders as the climate takes on a Mediterranean feel despite it being mid winter.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p34-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("091ww2/3 A German command vehicle gives a blazing Soviet T- 37A, amphibious tank, a wide berth on a narrow pass through the Yayla Mountains, driving south towards the Black Sea coast.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("I095ww2/3 Original German captions: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Icy winter storms sweep over the Crimea and hamper supplies on the coastal roads")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("096ww2/3 Original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romanians during winter fighting in the Yayla Mountains")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p35-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("094ww2/3 German soldiers with fir trees gathered to celebrate the birth of the Prince of Peace, Christmas 1941, in Bakhchisaray. The town of Bakhchysaraia is about eighteen miles south-west of Simferopol and thirty miles from Sevastopol.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("084ww2/3 Lieutenant General Dmitry Timofeyevich Kozlov, commander of the Crimean Front.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By the end of 1941, the whole Crimean Peninsula, except for besieged Sevastopol, was occupied by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wehrmacht")]), _vm._v(". To regain control over the lost territory an operation by two Soviet armies began on 26 December 1941. An amphibious landing, which was intended to break the siege of Sevastopol, was launched in different parts of Crimea’s eastern region. In less than a week the Red Army crushed enemy resistance and liberated the whole Kerch peninsula. However, it lost over 40,000 men, while German losses were estimated at 10,000. Despite the success of the landing, Soviet troops later lost the initiative and by May 1942 were again driven from the Kerch Peninsula. On 4 July the same year, Sevastopol surrendered. The whole of Crimea was in German hands.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("081ww2/3, 082ww2/3, 085ww2/3, 086ww2/3, 087ww2/3. Amphibious landings by Soviet forces were made on the Kerch Peninsula and it became known as Kerch-Feodosia Landing Operation. The Red Army lost 352,000 men in the fighting which followed, while the Axis, mainly Romanian and German troops, suffered 24,120 casualties. Soviet armies involved were the 44th Army, 47th Army and 51st Army.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p36-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("088ww2/3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalleutnant")]), _vm._v(" Hans Graf von Sponeck, commanding "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("XLII Armee Korps")]), _vm._v(". He withdrew his troops to avoid becoming encircled when Soviet forces landed on the Kerch Peninsula. He was charged with disobeying orders, court-martialed, imprisoned and shot on 23 July 1944, following the attempt to kill Hitler. Sponeck had no connection with the conspiracy. He had been complicit in war crimes against Jews – and other atrocities – in southern Ukraine and Crimea in 1941, during the period of his command.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p37-4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p38-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("078ww2/3 German infantry in mopping-up operations in the town of Feodosia, on the south coast.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("080ww2/3 It is claimed that it was Frederick the Great of Prussia who said that an army marches on its stomach: here a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feldwebel")]), _vm._v(" enjoys a leg of lamb during the drive through the Crimea.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("079ww2/3 German reserves awaiting orders to join the figthing in the town of Feodosia, January 1942.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The attack on the town of Kerch: a 20 mm flak gun team operating a Flak 30 or 38 and pouring down covering fire for attacking infantry.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("098ww2/3 The battle for the city of Feodosia: Germans entering the outskirts.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("100ww2-3 The port facilities at Kerch come under attack: this defensive position is being assaulted from the rear.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p40-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Iron and Steel Works at Kerch had been suspected of harbouring pockets of doggedly resistant enemy. Observers look for any signs of movement.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("102ww2/3 Abandoned vehicles, guns and military equipment left by the Soviet forces after their hurried evacuation of the Crimea. Original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The defeat at Kerch resembled that of the British at Dunkirk.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("103ww2/3, 104ww2/3. Original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They preferred to be prisoners of war rather than to die")]), _vm._v(". A slow death by starvation awaited most Russian prisoners. German officers question a Russian woman prisoner captured during the fighting for Kerch. The original caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Soviet female prisoner is interrogated.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("099ww2/3 General Erich von Manstein had reason to be satisfied with the outcome of the fighting to defeat the Soviet counter attack. The drive to the Caucasus and the oil fields was open. Only the Soviet naval base of Sevastopol remained to be captured.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41-4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("108ww2/3 German advance guard look out over Sevastopol, December 1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sevastopol was a valuable target for the Germans and Romanians. Its capture would enable the Axis forces to conduct sea and air operations against Soviet targets in the Caucasus ports and mountains, hence help in taking the oil fields. Having failed to capture the Soviet naval base of Sevastopol by open assault, the Axis opted to conduct siege warfare, which carried through to the summer of 1942. Finally, von Manstein attacked the encircled Soviet forces by massive strikes via land, sea and air. It eventually fell 4 July 1942.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("115ww2/3 von Manstein and his staff consider ways of bringing about the capture of the Soviet naval base using land, sea and air assaults.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p42-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("116ww2/3 German troops attacking a Soviet strongpoint under the cover of smoke provided by a canister.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("118ww2/3 Men of a rations carrying party come under fire as they take a meal to their comrades. The containers are Essentrager hot food carriers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("117ww2/3 German troops in action capturing the Soviet stronghold on Sapun Heights, Sevastopol. A corporal takes time for a cigarette.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p43-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("112ww2/3 A Stug III self propelled gun leads a command vehicle and half-tracks towards the end of the fighting for Sevastopol July 1942.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("119ww2/3 Generaloberst Wolfram von Richthofen commander of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fliegerkorps VIII")]), _vm._v(" with Romanian allies, (pointing at the map) planning air offensives in the Crimea. He saw the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luftwaffe’s")]), _vm._v(" involvement in the capture of Sevastopol divided into three tasks: attacking Soviet reserves beyond German artillery range; bombing raids against harbour facilities, airfields, fortresses and shipping; cooperating with German artillery to cancel out Soviet heavy artillery. He decided that shattering the fortifications through air bombardment should take priority.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("123ww2/3, 124ww2/3. A Heinkel He 111II carring an SC1000 bomb; release of an 1000 bomb.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("122ww2/3 A Soviet freighter on fire on the Black Sea. Re-supply for defenders of Sevastopol was made difficult.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("120ww2/3, 125ww2/3. Commander of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("III./StG 77")]), _vm._v(", Major Helmuth Bode en-route to attack a Soviet troop position near the port district of Sevastopol. Some dive bomber "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Staffeln")]), _vm._v(" were based at forward landing grounds within twenty-five miles of their targets around Sevastopol. During the height of the action crews were flying twelve sorties a day.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("121ww2/3 A remarkable photograph taken over the nose of a Ju 87 during its near vertical attack dive on one of the Sevastopol forts. Bombs dropped by the preceding Stuka can be seen exploding on the target.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("110ww2/3 The German self-propelled siege mortar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karl-Gerät;")]), _vm._v(" it had a barrel diameter of 60 cm (24 inches). The 124 ton vehicle was driven by a Daimler-Benz 12-cylinder liquid-cooled petrol engine. Seven weapons were built and some were diesel driven. In preparation for the attack on Sevastopol, scheduled for the early summer of 1942, two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karl-Geräte")]), _vm._v(" mortars, nicknamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thor")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Odin")]), _vm._v(", were positioned to bombard the Soviet concrete defences. On 20 May 1942 the"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("11.Armee")]), _vm._v(" reported the weapons were in position along with a total of seventy-two heavy and fifty light concrete-piercing shells. The main targets for the weapons were two twin-gunned armoured turrets of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maxim Gorky")]), _vm._v(" coastal defence battery.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("111ww2/3 The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schwerer Gustav")]), _vm._v(" was a German 80 centimetre (31.5 inch) railway gun. The siege of Sevastopol was the weapon's first combat test. It took 4,000 men five weeks to get the gun into a firing position; 500 men were needed to operate it. Installation began in early May 1942 and by 5 June the gun was ready to fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The following targets were selected:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Soviet coastal guns: 8 shells fired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Stalin")]), _vm._v(": 6 shells fired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Molotov")]), _vm._v(": 7 shells fired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("White Cliff")]), _vm._v(" an undersea ammunition magazine in Severnaya Bay. (The Soviet naval magazine was sited 100 feet under the sea with 33 feet of concrete protection. After 9 shells were fired, the target magazine was ruined and one of the boats in the bay sunk. Firing in support of an infantry attack on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Südwestspitze")]), _vm._v(", an outlying fortification: 7 shells fired:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Siberia")]), _vm._v(" knocked out of action.5 shells fired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maxim Gorky")]), _vm._v(" fortresses bombarded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maxim Gorky 1")]), _vm._v(" knocked out of action, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maxim Gorky 2")]), _vm._v(" damaged. 5 shells fired.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("113ww2/3 The battle for the Black Sea naval base is over and these German soldiers can walk upright with their weapons shouldered.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("114ww2/3 The smashed guns of Fort Gorky 1 can be examined by the artillerymen who did the damage.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("100ww2/3 On 1 July German forces entered Sevastopol and Hitler promoted General Manstein to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalfeldmarschall")]), _vm._v(" the same day. He looks pleased with the news as he surveys ruins of the city. During the Crimean campaign Manstein was indirectly involved in atrocities against the Soviet population, especially those committed by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einsatzgruppe D")]), _vm._v(", an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SS")]), _vm._v(" group engaged in eliminating the Jews of Europe. Manstein did nothing to prevent the killing of Jews and other civilians in the areas where his units were operating. After the war he was charged with war crimes and sentenced to eighteen years in prison.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The fall of Sevastopol was announced by a special radio communique:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-st"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Above the city and port flutter the German and Romanian flags. German and Romanian troops under the command of Colonel General von Manstein, steadfastly supported by Colonel General von Richthofen's battle-hardened air corps, after twenty-five days of fierce battle, have as of midday today, taken the most powerful land and sea fortress of all that have ever existed in the world.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption-c"
  }, [_vm._v("090ww2/3 Original German caption: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Children in their Soviet Paradise – Bolshevik slums in the Crimea")]), _vm._v(". These Russian families appear to be living in an abandoned stone quarry; their homes could have been destroyed in the fierce fighting. (Spring 1942).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d04e0a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter01.vue
// module id = 75
// module chunks = 0